import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class NegotiationDetailService extends BaseService {

    static url = "negotiation_details";
    static apis = {
       
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("negotiation_details");
    }

}

export default NegotiationDetailService